import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsOpen } from 'store/SideBar/selectorContext';
import { selectLocation } from 'store/Router/selectors';
import useMouseHover from 'Hooks/useMouseHover';
import { redirect } from 'store/Router/actions';
import SideBarSubMenu from '../SideBarSubMenu';
import SubPage from '../SubPage';
import SideBarBadge from '../SideBarBadge';
import isRouteActive from '../../isRouteActive';
import {
  Wrapper, Text, Icon, ItemWrapper, IconSlot, CompactBadgeWrapper, ExpandedBadgeWrapper
} from './styled';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

const SideBarItem = ({ icon, name, subMenu, showFF, badge }) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsOpen);
  const location = useSelector(selectLocation);
  const [showMenu, setShowMenu] = useState(false);
  const onHide = () => setShowMenu(false);
  const onShow = () => setShowMenu(true);
  const [mouseEnterDebounced, mouseLeaveDebounced] = useMouseHover(onShow, onHide);

  const hasSelectedItem = subMenu.some(({ url, subPaths }) => isRouteActive(location.pathname, url, subPaths));
  const hasOneChild = subMenu.length === 1;
  const canShowMenu = showMenu && (((isOpen && !hasOneChild && !hasSelectedItem) || !isOpen));
  const canShowSubPages = (isOpen && hasSelectedItem && !hasOneChild);

  const enabledItems = subMenu.filter((item) => get(item, 'enabledByRole', false));
  const badgeLabel = get(badge, 'label', '');
  const compactBadgeLabel = get(badge, 'compactLabel', badgeLabel);

  const selectFirst = () => {
    const enabledByFeature = get(enabledItems, '[0].enabledByFeature', false);
    if (enabledByFeature) {
      const url = get(enabledItems, '[0].url', '');
      dispatch(redirect(url));
    } else {
      const FF = get(enabledItems, '[0].FF', {});
      showFF(FF);
    }
  };

  if (isEmpty(enabledItems)) return null;
  return (
    <Wrapper onMouseEnter={ subMenu && mouseEnterDebounced } onMouseLeave={ subMenu && mouseLeaveDebounced } title={ name }>
      <ItemWrapper selected={ hasSelectedItem || canShowMenu } onClick={ selectFirst } data-tour={ name }>
        <IconSlot>
          <Icon selected={ hasSelectedItem || canShowMenu } children={ icon } name={ name } />
          { !isOpen && compactBadgeLabel && (
            <CompactBadgeWrapper>
              <SideBarBadge compact label={ compactBadgeLabel } />
            </CompactBadgeWrapper>
          )}
        </IconSlot>
        { isOpen && <Text selected={ hasSelectedItem } children={ name } /> }
        { isOpen && badgeLabel && (
          <ExpandedBadgeWrapper>
            <SideBarBadge label={ badgeLabel } />
          </ExpandedBadgeWrapper>
        )}
      </ItemWrapper>
      { canShowMenu && <SideBarSubMenu items={ enabledItems } name={ name } showFF={ showFF } /> }
      { canShowSubPages && enabledItems.map(({ name, url, subPaths, enabledByFeature, FF }) => <SubPage name={ name } url={ url } subPaths={ subPaths } key={ name } enabledByFeature={ enabledByFeature } FF={ FF } showFF={ showFF } />) }
    </Wrapper>
  );
};

export default SideBarItem;
